import React, { useState } from 'react';
import axios from 'cccisd-axios';
import { Formik, Form, Field, CccisdSelect } from 'cccisd-formik';
import ClickButton from 'cccisd-click-button';
import Modal from 'cccisd-modal';
import { headerStyle } from '../../index.js';

const Boilerplate = window.cccisd.boilerplate;

const UpdateDeployer = ({ forceUpdate }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState(null);
    const [currentTag, setCurrentTag] = useState(null);

    async function fetchTags() {
        const response = await axios.get(Boilerplate.route('api.monitoring.devops.app-info'), {
            params: {
                apphandle: 'dev-ops/deployer',
            },
        });

        let allTags = response?.data?.data?.tags;
        if (!Array.isArray(allTags)) {
            allTags = [];
        }

        allTags.sort((a, b) => {
            const isAValid = /^[\d]{1,}\.[\d]{1,}\.[\d\-_A-Za-z]{1,}$/.test(a);
            const isBValid = /^[\d]{1,}\.[\d]{1,}\.[\d\-_A-Za-z]{1,}$/.test(b);
            if (!isAValid && !isBValid) {
                return a.localeCompare(b);
            }
            if (!isAValid) {
                return 1;
            }
            if (!isBValid) {
                return -1;
            }

            const partsA = a.split('.');
            const partsB = b.split('.');

            for (let i = 0; i < 3; i++) {
                const aTag = parseInt(partsA[i], 10);
                const bTag = parseInt(partsB[i], 10);
                if (aTag === bTag) {
                    if (i === 2) {
                        return partsA[i].localeCompare(partsB[i]);
                    }
                    continue;
                }

                if (aTag < bTag) {
                    return 1;
                }
                if (bTag < aTag) {
                    return -1;
                }
            }

            return 0;
        });

        setTags(allTags);
        setSelectedTag(allTags[0]);
        setCurrentTag(response?.data?.data?.currentTag);
    }

    async function handleSubmit(closeModal) {
        setIsLoading(true);
        await axios.post(Boilerplate.route('api.monitoring.devops.job.update-deployer'), {
            tag: selectedTag,
        });
        setIsLoading(false);
        closeModal();
    }

    function renderContent({ closeModal }) {
        return (
            <div>
                <Formik
                    render={() => (
                        <Form>
                            <Field
                                name="tag"
                                component={fieldProps => (
                                    <CccisdSelect
                                        {...fieldProps}
                                        onChange={event => {
                                            fieldProps.field.onChange(event);
                                            setSelectedTag(event.currentTarget.value);
                                        }}
                                    />
                                )}
                                options={tags.map(t => ({ value: t, label: t }))}
                                label={
                                    <div>
                                        Tag to deploy
                                        {currentTag && (
                                            <p className="mb-0 fw-light fst-italic">
                                                <small>Current tag: {currentTag}</small>
                                            </p>
                                        )}
                                    </div>
                                }
                                style={{ width: 'fit-content' }}
                            />
                        </Form>
                    )}
                />
                <div className="mt-5 d-flex justify-content-between">
                    <ClickButton
                        onClick={() => closeModal()}
                        type="button"
                        className="btn btn-primary"
                        title="Cancel"
                        isDisabled={isLoading}
                    />
                    <ClickButton
                        onClick={() => handleSubmit(closeModal)}
                        isLoading={isLoading}
                        isDisabled={isLoading}
                        type="button"
                        className="btn btn-warning"
                        title="Update Deployer"
                    />
                </div>
            </div>
        );
    }

    return (
        <Modal
            trigger={
                <button className="btn btn-primary me-2" type="button">
                    Update Deployer
                </button>
            }
            title="Update Deployer"
            headerStyle={headerStyle}
            afterClose={() => forceUpdate()}
            render={renderContent}
            beforeShow={() => fetchTags()}
        />
    );
};

export default UpdateDeployer;
